import { PortalConfig } from './../../services/portal-config';
import { Router } from '@angular/router';
import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NotFoundComponent {
  origin: string;
  
  constructor (
    private router: Router,
    private portalConfig: PortalConfig,
  ) {
    this.origin = this.portalConfig.publicConfig.APP_ORIGIN;
  }

  goToLogin () {
    this.router.navigate(['/home']);
  }
}
